import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
// Reusable Components
// const SectionHeading = ({ text }) => <p className={styles.ques_heading}>{text}</p>;

// const SectionHeading = ({ text, sx }) => (
//   <p className={styles.ques_heading} style={sx} >{text}</p>
// );

const Economic222 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    devlopmentStrategy: "",
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        const data = response.data.data.GeneralDisclosures2021 || {};
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        setFormData({
          devlopmentStrategy: data.devlopmentStrategy || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    if (!formData.devlopmentStrategy) {
      newErrors.devlopmentStrategy = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    // if (!validateForm()) return;  // Validate form before submission
    if (!disabled) {
      const payload = {
        submitted2_22: true,
        type: "GeneralDisclosures2021",
        ...formData,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`${api}/gri/update?Id=${id}`, payload);
        navigate(`/gri/general-disclosure/2-23/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-23/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading}>
        2-22 Statement on sustainable development strategy
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}
        <SectionHeading
          text="a. Please provide a statement from the highest governance body (board of directors)
       or the most senior executive outlining the relevance of sustainable development to the organization and its strategy for contributing to achieving it."
          sx={{ marginTop: hide ? "-1rem" : "2rem" }}
        />
        <CustomTextField
          value={formData.devlopmentStrategy}
          onChange={(e) =>
            handleInputChange("devlopmentStrategy", e.target.value)
          }
          error={errors.devlopmentStrategy}
          helperText={errors.devlopmentStrategy}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox
                  url={"/gri"}
                  handleSubmit={handleSubmit}
                  url1={`/gri/general-disclosure/2-23/${id}`}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic222;
